export default __webpack_public_path__ + "static/media/promodx.fc05c60c.png";